import type { ReactNode } from 'react'

import { useT } from '../i18n'

import type { Tone } from './Badge.types'

export function Badge({
  tone = 'default',
  children,
  title,
}: {
  tone?: Tone
  children: ReactNode
  title?: string
}) {
  return (
    <span
      className={`badge ${tone !== 'default' ? `badge--${tone}` : ''}`}
      title={title}
    >
      {children}
    </span>
  )
}

/** Monochrome status language: fill and line style carry meaning, labels always present. */
const STATUS_TONE: Record<string, Tone> = {
  PUBLISHED: 'solid',
  ACTIVE: 'solid',
  ENABLED: 'solid',
  READY: 'solid',
  SUCCESS: 'default',
  HEALTHY: 'default',
  DRAFT: 'default',
  INSTALLED: 'default',
  IN_REVIEW: 'dashed',
  SCHEDULED: 'dashed',
  PROCESSING: 'dashed',
  UPLOADING: 'dashed',
  INVITED: 'dashed',
  DISCOVERED: 'muted',
  ARCHIVED: 'muted',
  DISABLED: 'muted',
  DELETED: 'muted',
  UNKNOWN: 'muted',
  FAILED: 'danger',
  FAILURE: 'danger',
  LOCKED: 'danger',
  UNHEALTHY: 'danger',
}

export function StatusBadge({ status }: { status: string }) {
  const { t } = useT()

  return (
    <Badge tone={STATUS_TONE[status] ?? 'default'}>
      {t.status[status] ?? status.replace(/_/g, ' ')}
    </Badge>
  )
}
